module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/ogp-f08b6db0616ed40fee4ea17b2e98eced.png";